import styled from "styled-components";
import { colors } from "../../../../assets";

export const WPStatusModalContainer = styled.div`
  display: flex;
  color: ${colors["PR-001-100"]};
  position: fixed;
  z-index: 100;
  background: ${colors["background-modal"]};
  left: 0;
  width: 100%;
  top: 0;
  align-items: center;
  justify-content: center;
  height: 100%;

  .wp-status-modal-container {
    background: #ffffff;
    border-radius: 3px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    padding: 20px 20px 40px 20px;
    max-width: 1200px;
    width: 70vw;
  }

  .wp-status-modal-container-table {
    width: 100%;
    overflow-x: auto;
  }

  .wp-status-modal-container-close {
    text-align: right;
    img {
      max-width: 18px;
      cursor: pointer;
    }
  }

`;
